export function unwrapApiData<T = unknown>(payload: unknown): T {
  const root = payload as any;
  return (root?.data?.data ?? root?.data ?? root) as T;
}

export function unwrapApiArray<T = unknown>(payload: unknown): T[] {
  const data = unwrapApiData<any>(payload);
  if (Array.isArray(data)) return data as T[];
  if (Array.isArray(data?.items)) return data.items as T[];
  if (Array.isArray(data?.records)) return data.records as T[];
  if (Array.isArray(data?.results)) return data.results as T[];
  if (Array.isArray(data?.leaderboard)) return data.leaderboard as T[];
  if (Array.isArray(data?.notifications)) return data.notifications as T[];
  return [];
}

export function unwrapApiObject<T extends Record<string, unknown> = Record<string, unknown>>(
  payload: unknown,
  fallback = {} as T,
): T {
  const data = unwrapApiData<any>(payload);
  return data && typeof data === "object" && !Array.isArray(data) ? (data as T) : fallback;
}
